module.exports = __webpack_public_path__ + "static/media/G0142657_China-36.8b7ccfc2.png";